import { useCallback } from "react";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
export const useSendWidgetEditTelemetry = () => {
  const sendTelemetry = useSendTelemetry("search-widget");
  return useCallback(
    () => sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.WIDGET_EDIT_TOGGLED, {
      app_action_value: "widget-edit-button"
    }),
    [sendTelemetry]
  );
};
export const useSendWidgetEditCancelTelemetry = () => {
  const sendTelemetry = useSendTelemetry("search-widget");
  return useCallback(
    () => sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.WIDGET_EDIT_CANCEL_CLICKED, {
      app_action_value: "widget-edit-cancel-button"
    }),
    [sendTelemetry]
  );
};
export const useSendWidgetConfigUpdateTelemetry = () => {
  const sendTelemetry = useSendTelemetry("search-widget");
  return useCallback(
    () => sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.WIDGET_CONFIG_UPDATED, {
      app_action_value: "widget-edit-update-button"
    }),
    [sendTelemetry]
  );
};
